/** @deprecated */
export const NETBOX_DOMAIN = 'https://box.cutwise.com';
export const NETBOX_ORIGIN = 'box.cutwise.link';

export const CONNECT_TIMEOUT = 3000;
